import React from "react";
import { Link } from 'react-router-dom';

export const Privacy = () => {
  return (
    <div className="privacy-policy-container">
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="privacy-content">
              <Link to="/" className="back-link mb-4 d-inline-block">
                ← Back to Home
              </Link>
              
              <h1 className="mb-4">Privacy Policy</h1>
              <p className="website-url mb-2">www.stabolut.com</p>
              <p className="effective-date mb-4">Effective date: 1st April 2023</p>
              
              <div className="policy-section">
                <p>
                  Stabolut Ltd ("us", "we", or "our") operates the stabolut.com website and the Stabolut mobile application 
                  (collectively referred to as the "Service"). This Privacy Policy informs you of our policies regarding the collection, 
                  use, and disclosure of personal data when you use our Service and the choices you have associated with that data.
                </p>
                <p>
                  By using the Service, you agree to the collection and use of information in accordance with this policy. 
                  Unless otherwise defined in this Privacy Policy, the terms used in this Privacy Policy have the same meanings 
                  as in our Terms and Conditions.
                </p>
              </div>

              <div className="policy-section">
                <h2>1. Definitions</h2>
                <ul>
                  <li><strong>Service:</strong> The stabolut.com website and the Stabolut mobile application operated by Stabolut Ltd.</li>
                  <li><strong>Personal Data:</strong> Data about a living individual who can be identified from that data (or from those and other information either in our possession or likely to come into our possession).</li>
                  <li><strong>Usage Data:</strong> Data collected automatically either generated by the use of the Service or from the Service infrastructure itself (for example, the duration of a page visit).</li>
                  <li><strong>Cookies:</strong> Small pieces of data stored on your device (computer or mobile device).</li>
                </ul>
              </div>

              <div className="policy-section">
                <h2>2. Information Collection and Use</h2>
                <p>
                  While using our website, we may ask you to provide us with certain personally identifiable information 
                  that can be used to contact or identify you ("Personal Data"). The mobile application does not collect 
                  any Personal Data. Personal Data collected on the website may include, but is not limited to:
                </p>
                <ul>
                  <li>Email address</li>
                  <li>First name and last name</li>
                  <li>Username</li>
                </ul>
              </div>

              <div className="policy-section">
                <h2>3. Use of Data</h2>
                <p>Stabolut Ltd uses the collected data for various purposes, including:</p>
                <ul>
                  <li>To provide and maintain the Service</li>
                  <li>To notify you about changes to our Service</li>
                  <li>To allow you to participate in interactive features of our Service when you choose to do so</li>
                  <li>To provide customer care and support</li>
                  <li>To provide analysis or valuable information so that we can improve the Service</li>
                  <li>To monitor the usage of the Service</li>
                  <li>To detect, prevent and address technical issues</li>
                </ul>
              </div>

              <div className="policy-section">
                <h2>4. Transfer of Data</h2>
                <p>
                  Your information, including Personal Data, may be transferred to and maintained on servers located outside of your country, 
                  where the data protection laws may differ from those of your jurisdiction. By providing your Personal Data, you agree to 
                  this transfer, storage, and processing of your information.
                </p>
              </div>

              <div className="policy-section">
                <h2>5. Disclosure of Data</h2>
                <p>Stabolut Ltd may disclose your Personal Data in the good faith belief that such action is necessary to:</p>
                <ul>
                  <li>Comply with a legal obligation</li>
                  <li>Protect and defend the rights or property of Stabolut Ltd</li>
                  <li>Prevent or investigate possible wrongdoing in connection with the Service</li>
                  <li>Protect the personal safety of users of the Service or the public</li>
                  <li>Protect against legal liability</li>
                </ul>
              </div>

              <div className="policy-section">
                <h2>6. Security of Data</h2>
                <p>
                  The security of your data is important to us, but no method of transmission over the Internet or method of 
                  electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, 
                  we cannot guarantee its absolute security.
                </p>
              </div>

              <div className="policy-section">
                <h2>7. Service Providers</h2>
                <p>
                  We may employ third-party companies and individuals to facilitate our Service, provide the Service on our behalf, 
                  perform Service-related services, or assist us in analyzing how our Service is used. These third parties have access 
                  to your Personal Data only to perform these tasks on our behalf and are obligated not to disclose or use it for any 
                  other purpose.
                </p>
              </div>

              <div className="policy-section">
                <h2>8. Children's Privacy</h2>
                <p>
                  Our Service does not address anyone under the age of 18 ("Children"). We do not knowingly collect personally 
                  identifiable information from anyone under the age of 18. If you are a parent or guardian and you are aware 
                  that your child has provided us with Personal Data, please contact us.
                </p>
              </div>

              <div className="policy-section">
                <h2>9. Digital Assets and Wallet Privacy</h2>
                <p>
                  As a provider of wallet services for digital asset payments, we implement additional privacy measures and 
                  considerations for our users. The following clauses are specific to our wallet services:
                </p>
                <ul>
                  <li><strong>Transaction Data:</strong> When you use our Wallet for digital asset payments, we may collect 
                  transaction-related data, such as transaction amount, digital asset type, wallet addresses, and transaction 
                  timestamps.</li>
                  <li><strong>Wallet Backup and Recovery:</strong> Our wallet service offers backup and recovery options to help 
                  you protect your digital assets. Any backup data is encrypted and stored securely on your device itself.</li>
                  <li><strong>Anonymity and Pseudonymity:</strong> Digital asset transactions are often pseudonymous in nature, 
                  meaning that they do not reveal the real-world identity of the parties involved.</li>
                  <li><strong>Third-Party Integrations:</strong> We may integrate our Wallet services with third-party providers, 
                  such as exchanges, payment processors, or other digital asset services.</li>
                </ul>
              </div>

              <div className="policy-section">
                <h2>10. Compliance with Seychelles Privacy Laws, CCPA, and GDPR</h2>
                <p>
                  As a company incorporated in Seychelles with global users, Stabolut Ltd is committed to complying with the 
                  privacy laws and regulations applicable in Seychelles and the provisions of the California Consumer Privacy 
                  Act (CCPA) and the General Data Protection Regulation (GDPR).
                </p>
                <h3>GDPR Rights:</h3>
                <ul>
                  <li>The right to access, update, or delete your personal data</li>
                  <li>The right of rectification</li>
                  <li>The right to object</li>
                  <li>The right of restriction</li>
                  <li>The right to data portability</li>
                  <li>The right to withdraw consent</li>
                </ul>
              </div>

              <div className="policy-section">
                <h2>11. Contact Us</h2>
                <p>
                  If you have any questions about this Privacy Policy, or to exercise your rights under Seychelles Privacy Laws, 
                  CCPA, GDPR, or if you have specific concerns related to the Wallet for digital asset payments, please contact 
                  us by email: <a href="mailto:contact@stabolut.com">contact@stabolut.com</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}; 